// extracted by extract-css-chunks-webpack-plugin
module.exports = {"hero":"-RHTLA","heroContent":"qDUbuq","heroDescription":"_3uZY-f","bannerLink":"_1fXxmv","heroImage":"_2nU2hE"};